import { render, staticRenderFns } from "./StartupsUpdates.vue?vue&type=template&id=5b462fd8&scoped=true&"
import script from "./StartupsUpdates.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsUpdates.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b462fd8",
  null
  
)

export default component.exports